/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Dutch (Netherlands)
export default {
	'identity.account-menu.account-details.view-profile-link': 'Profiel bekijken',
	'identity.account-menu.account-menu-content.log-out-button': 'Uitloggen',
	'identity.account-menu.account-menu-content.switch-account-button': 'Account wisselen',
	'identity.account-menu.account-menu-details.managed-account':
		'Dit account wordt beheerd door <b>{managedBy}</b>.',
	'identity.account-menu.account-menu-popup.skeleton.tooltip': 'Account',
};
